






















import { EntryDirection, LocationEntryDto } from "@saysimple-platform/dtos";
import { defineComponent, PropType } from "@vue/composition-api";
import { BButton, VBTooltip } from "bootstrap-vue";

export default defineComponent({
    components: {
        BButton,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        entry: {
            type: Object as PropType<LocationEntryDto>,
            required: true,
        },
        groupDirection: {
            type: String as PropType<EntryDirection>,
            required: false,
        },
    },
});
